import { useContext, useEffect, useRef, useState } from "react";
import { Form, Button, Steps, notification, ConfigProvider, Card } from "antd";
import { useTranslation } from "react-i18next";
import GlobalContext from "../../../context/GlobalContext";
import classes from "./LancementSessionFormationNonHomologuee.module.css";
import dayjs from "dayjs";
import { useLocation, useNavigate } from "react-router-dom";
import EtapeDonneesGeneralesFNH from "./EtapeDonneesGeneralesFNH/EtapeDonneesGeneralesFNH";
import {
  addAffaire,
  getDetailsEpfByDirector,
  saveAffaire,
} from "../../../api/geoprod";
import { useLoader } from "../../../context/LoaderContext";
import EtapeListeApprenants from "./EtapeListeApprenantsFNH/EtapeListeApprenants";
import EtapeRecapitulatifFNH from "./EtapeRecapitulatif/EtapeRecapitulatifFNH";
import axiosInstance from "../../../utils/axios";

const LancementSessionFormationNonHomologuee = ({ typesession }) => {
  const [form] = Form.useForm();
  const { globalData, setGlobalData, currentStep, setCurrentStep } =
    useContext(GlobalContext);
  const { t } = useTranslation();
  // const [currentStep, setCurrentStep] = useState(
  //   Number(sessionStorage.getItem("currentStep")) || 0
  // );

  const navigate = useNavigate();
  const [periode, setPeriode] = useState("Semestrielle");
  const ref = useRef();
  const params = useLocation();
  const dataFormationNonHomloguee = params?.state?.dataFormationNonHomloguee;
  const natureFormation = params?.state?.natureFormation;
  const { setIsLoading, isLoading } = useLoader();
  const id_session_formation =
    typesession === "non_homologuee"
      ? params?.state?.id_session_formation_non_homologuee
      : params?.state?.id_session_formation_continue;
  const steps = [
    {
      title: (
        <>
          <div>Données Générales</div>
          <div style={{ fontSize: 12, color: "gray" }}>
            Informations de base
          </div>
        </>
      ),
      content: (
        <EtapeDonneesGeneralesFNH
          form={form}
          natureFormation={natureFormation}
          id_session_formation={id_session_formation}
          typesession={typesession}
        />
      ),
    },

    {
      title: (
        <>
          <div>Participants</div>
          <div style={{ fontSize: 12, color: "gray" }}>Participants</div>
        </>
      ),
      content: (
        <EtapeListeApprenants
          form={form}
          globalData={globalData}
          periode={periode}
          setPeriode={setPeriode}
          id_session_formation={id_session_formation}
          typesession={typesession}
        />
      ),
    },

    {
      title: (
        <>
          <div>Récapitulatif</div>
          <div style={{ fontSize: 12, color: "gray" }}>Validation finale</div>
        </>
      ),
      content: (
        <EtapeRecapitulatifFNH
          globalData={globalData}
          typesession={typesession}
        />
      ),
    },
  ];

  const formatDate = (date) => dayjs(date).format("DD/MM/YYYY");

  const formatPeriodes = (list, dateNaissance) =>
    list?.map((p) => ({
      ...p,
      [dateNaissance]: formatDate(p[dateNaissance]),
    }));

  const saveSession = () => {
    let x = { ...form.getFieldsValue(), ...dataFormationNonHomloguee };
    if (currentStep === 0) {
      x = {
        ...x,
        date_debut_session_formation: formatDate(
          x.date_debut_session_formation
        ),
        date_fin_session_formation: formatDate(x.date_fin_session_formation),
      };
    } else if (currentStep === 1) {
      x = {
        ...x,
        apprenants: formatPeriodes(x.apprenants, "dateNaissance"),
      };
    } else {
      x = {
        ...globalData,
        ...x,
      };
    }

    const value = { ...globalData, ...x };
    sessionStorage.setItem("globalData", JSON.stringify(value));
    setGlobalData(value);
    sessionStorage.setItem("currentStep", currentStep.toString());
  };

  const items = steps.map((item, index) => ({
    key: index.toString(),
    title: item.title,
  }));

  const nextStep = async () => {
    form.validateFields().then(async () => {
      if (currentStep < steps.length - 1) {
        sessionStorage.setItem("currentStep", currentStep + 1);
        setCurrentStep(currentStep + 1);
        saveSession();
      } else {
        setIsLoading(true);

        const commonFieldsOne = [
          {
            label: t("Secteur"),
            type: "text",
            value: globalData["secteur"],
          },
          {
            label: t("Domaine"),
            type: "text",
            value: globalData["domaine"],
          },
        ];

        const commonFieldsTwo = [
          {
            label: t("Date de début de la session de formation"),
            type: "text",
            value: globalData["date_debut_session_formation"],
          },
          {
            label: t("Date de fin de la session de formation"),
            type: "text",
            value: globalData["date_fin_session_formation"],
          },
          {
            label: t("Lieu de la formation"),
            type: "text",
            value: globalData["lieu_formation"],
          },
          {
            label: t("Formateurs"),
            type: "select multiple",
            value: ["291a6f1a12e6ea4ae27eb191f2d4c4c2"],
          },
          {
            label: t("Nombre des participants"),
            type: "text",
            value: globalData["nb_apprenants"],
          },
        ];

        const extraFieldSousSecteur = {
          label: t("Sous-secteur"),
          type: "text",
          value: globalData["sous_secteur"],
        };

        const extraFieldsContinue = [
          {
            label: t("Gouvernorat"),
            type: "text",
            value: globalData["gouvernorat"],
          },
          {
            label: t("Droit de tirage"),
            type: "text",
            value: globalData["droit_tirage"],
          },
          {
            label: t("Crédit d'impôt"),
            type: "text",
            value: globalData["credit_impot"],
          },
        ];

        const elementAccordionOne =
          typesession === "non_homologuee"
            ? [
                ...commonFieldsOne.slice(0, 1),
                extraFieldSousSecteur,
                commonFieldsOne[1],
              ]
            : commonFieldsOne;

        const elementAccordionTwo =
          typesession === "non_homologuee"
            ? commonFieldsTwo
            : [
                ...commonFieldsTwo.slice(0, 3),
                ...extraFieldsContinue,
                ...commonFieldsTwo.slice(3),
              ];

        const dataJson = [
          {
            title: t("Données Générales"),
            subtitle: t("Informations de base"),
            type: "form",
            sections: [
              {
                fields: elementAccordionOne,
                name: "Informations par défaut de la session",
                type: "pannel",
              },
              {
                fields: elementAccordionTwo,
                name: "Données à configurer pour la session",
                type: "pannel",
              },
            ],
          },
          {
            title: t("Participants"),
            subtitle: t("Participants"),
            type: "form",
            sections: [
              {
                fields: [
                  {
                    columns: [
                      { dataIndex: "typeIdentifiant", title: "Type" },
                      { dataIndex: "nom", title: "Nom" },
                      { dataIndex: "prenom", title: "Prénom" },
                      { dataIndex: "identifiant", title: "Identifiant" },
                      {
                        dataIndex: "dateNaissance",
                        title: "Date de naissance",
                      },
                      { dataIndex: "structure", title: "Structure" },
                      { dataIndex: "niveau", title: "Niveau" },
                    ],
                    rows: globalData?.apprenants?.map((apprenant) => ({
                      typeIdentifiant: apprenant?.typeIdentifiant,
                      nom: apprenant?.nom,
                      prenom: apprenant?.prenom,
                      identifiant: apprenant?.identifiant,
                      dateNaissance: apprenant?.dateNaissance,
                      structure: apprenant?.structure,
                      niveau: apprenant?.niveau,
                    })),
                    type: "table",
                  },
                ],
              },
            ],
          },
        ];

        const typeSoumissionDemande =
          typesession === "non_homologuee"
            ? "session_formation_non_homologuee"
            : "session_formation_continue";
        const payload = {
          current_step: 0,
          additional_form: "{}",
          json_prod: {
            ...globalData,
            ...form.getFieldsValue(),
            ...params.state.dataFormationNonHomloguee,
            id_formation_session: params?.state?.id_formation,
            dataJson: dataJson,
          },
        };
        let id_affaire;
        if (typesession === "non_homologuee") {
          id_affaire = sessionStorage.getItem(
            "id_session_formation_non_homologuee"
          );
        } else {
          id_affaire = sessionStorage.getItem("id_session_formation_continue");
        }
        debugger
        const listApprenatsJsons = globalData?.apprenants?.map((e) => {
          return {
            name: e?.nom,
            surname: e?.prenom,
            DN: dayjs(e?.dateNaissance, "DD/MM/YYYY").format("YYYY-MM-DD"),
            cin: e.typeIdentifiant === "cin" ? e.identifiant : "",
            extrait_naissance: e.typeIdentifiant !== "cin" ? e.identifiant : "",
            niveau_etud: e.niveau,
            id_formation: parseInt(params?.state?.id_formation),
            data_from: {
              typeIdentifiant: e.typeIdentifiant,
              niveau: e.niveau,
            },
            id_affaire: id_affaire,
            nationality: "تونسية",
          };
        });

        await axiosInstance.post(
          `${import.meta.env.VITE_APP_GEOPROD_API}/add_list_apprenant`,
          {
            apprenants: listApprenatsJsons,
          },
          {
            headers: {
              Idsession: JSON.parse(sessionStorage.getItem("-x-token-user"))
                ?.Acces_Token,
            },
          }
        ).then(async(res)=>{
          const data = await saveAffaire(
            payload,
            params.state.etat === "dossierManquant"
              ? "soumissionDossierManquantSessionNonHomologueeOrContinue"
              : "soumissionSessionFormationNonHomologueeOrContinue",
            setIsLoading,
            typeSoumissionDemande
          );
          if (data) {
            if (typesession === "non_homologuee") {
              sessionStorage.removeItem("id_session_formation_non_homologuee");
            } else {
              sessionStorage.removeItem("id_session_formation_continue");
            }
            navigate("/demandes");
            setIsLoading(false);
          }
        }).catch((err)=>{
          setIsLoading(false);
          notification.error({
            message:t("Erreur"),
            description:t("Erreur d'enregistrement des apprenants")
          })

        })
       
      }
    });
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
      sessionStorage.setItem("currentStep", (currentStep - 1).toString());
    }
  };

  const handleClickOutside = async (event) => {
    const globalDataSession = JSON.parse(sessionStorage.getItem("globalData"));
    // debugger
    if (
      ref.current &&
      !ref?.current?.contains(event?.target) &&
      !id_session_formation
    ) {
      const payload = {
        current_step: Number(sessionStorage.getItem("currentStep")),
        json_prod: { ...form.getFieldsValue(), ...globalDataSession },
        registration_number: globalDataSession?.registration_number,
        date_debut_session: form.getFieldsValue()[
          "date_debut_session_formation"
        ]
          ? dayjs(form.getFieldsValue()["date_debut_session_formation"]).format(
              "DD/MM/YYYY"
            )
          : globalDataSession?.date_debut_session_formation
          ? globalDataSession?.date_debut_session_formation
          : "",
        date_fin_session: globalDataSession?.date_fin_session_formation
          ? globalDataSession?.date_fin_session_formation
          : "",
      };

      if (form.getFieldsValue()["date_debut_session_formation"]) {
        payload.json_prod.date_debut_session_formation = formatDate(
          form.getFieldsValue()["date_debut_session_formation"]
        );
      }
      if (form.getFieldsValue()["date_fin_session_formation"]) {
        payload.json_prod.date_fin_session_formation = formatDate(
          form.getFieldsValue()["date_fin_session_formation"]
        );
      }

      sessionStorage.setItem("payload", JSON.stringify(payload));
    }
  };

  const lancementSessionFormation = async () => {
    setIsLoading(true);
    getDetailsEpfByDirector()
      .then(async (responseDetailsEpf) => {
        const json_prod = {
          registration_number:
            responseDetailsEpf?.data?.message?.registration_number,
          establishment_data_commercial_name:
            responseDetailsEpf?.data?.message
              ?.establishment_data_commercial_name,
          establishment_data_official_name:
            responseDetailsEpf?.data?.message?.establishment_data_official_name,
          legal_entity_official_name:
            responseDetailsEpf?.data?.message?.legal_entity_official_name,
          establishment_director_data_last_name:
            responseDetailsEpf?.data?.message
              ?.establishment_director_data_last_name,
          establishment_director_data_first_name:
            responseDetailsEpf?.data?.message
              ?.establishment_director_data_first_name,
          establishment_data_governorate:
            responseDetailsEpf?.data?.message?.establishment_data_governorate,
          establishment_data_delegation:
            responseDetailsEpf?.data?.message?.establishment_data_delegation,
          establishment_data_tax_number:
            responseDetailsEpf?.data?.message?.establishment_data_tax_number,
          legal_entity_tax_number:
            responseDetailsEpf?.data?.message?.legal_entity_tax_number,
          numero_matricule_fiscal_numero_IURNE:
            responseDetailsEpf?.data?.message
              ?.numero_matricule_fiscal_numero_IURNE,
          numero_matricule_fiscal_IURNE:
            responseDetailsEpf?.data?.message?.numero_matricule_fiscal_IURNE,
          establishment_director_data_phone_number:
            responseDetailsEpf?.data?.message
              ?.establishment_director_data_phone_number,
          establishment_data_training_type:
            responseDetailsEpf?.data?.message?.establishment_data_training_type,
          ...globalData,
          ...form.getFieldsValue(),
          id_formation_session: params?.state?.id_formation,
        };

        const payload_add_affaire = {
          ligne_produit:
            typesession === "non_homologuee"
              ? import.meta.env
                  .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_NON_HOMOLOGUEE
              : import.meta.env
                  .VITE_APP_ID_LIGNE_PRODUIT_DEMANDE_CREATION_SESSION_FORMATION_CONTINUE,
          id_opp: null,
          nom_produit: "THAMM PRODUCT (  )",
          id_produit: "d728587fff2d87201eae0a158507d814",
          cmp: "987654300",
          affaire_parent: "",
          user_id: JSON.parse(sessionStorage.getItem("-x-token-user")).id_user,
          date_effet: "2024-01-02",
          souscription: "2024-01-02",
          id_fractionnement: 11,
          affected: "1002237",
          id_formation: params?.state?.id_formation,
          data_form_prod: JSON.stringify(json_prod),
          id_formation_session: params?.state?.id_formation,
        };

        const data = await addAffaire(payload_add_affaire, "soumission", null);
        if (data) {
          setIsLoading(false);
          if (typesession === "non_homologuee") {
            sessionStorage.setItem(
              "id_session_formation_non_homologuee",
              data?.id_affaire
            );
          } else {
            sessionStorage.setItem(
              "id_session_formation_continue",
              data?.id_affaire
            );
          }
        }
      })
      .catch((error) => {
        notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
          duration: 0,
        });
        setIsLoading(false);
      });
  };

  useEffect(() => {
    form.setFieldsValue(
      JSON.parse(sessionStorage.getItem("globalData"))
        ? {
            ...JSON.parse(sessionStorage.getItem("globalData")),
            date_debut_session_formation: JSON.parse(
              sessionStorage.getItem("globalData")
            )?.date_debut_session_formation
              ? dayjs(
                  JSON.parse(sessionStorage.getItem("globalData"))
                    ?.date_debut_session_formation,
                  "DD/MM/YYYY"
                )
              : null,
            date_fin_session_formation: JSON.parse(
              sessionStorage.getItem("globalData")
            )?.date_fin_session_formation
              ? dayjs(
                  JSON.parse(sessionStorage.getItem("globalData"))
                    ?.date_fin_session_formation,
                  "DD/MM/YYYY"
                )
              : null,
            apprenants: JSON.parse(
              sessionStorage.getItem("globalData")
            )?.apprenants?.map((p) => ({
              ...p,
              dateNaissance: p.dateNaissance
                ? dayjs(p.dateNaissance, "DD/MM/YYYY")
                : null,
            })),
          }
        : {
            ...form.getFieldsValue(),
            secteur:
              dataFormationNonHomloguee?.training_nature_data
                ?.training_type_data_sector,
            sous_secteur:
              dataFormationNonHomloguee?.training_nature_data
                ?.training_type_data_sub_sector,
            domaine:
              dataFormationNonHomloguee?.training_nature_data
                ?.training_type_data_domain,
          }
    );
    setGlobalData(JSON.parse(sessionStorage.getItem("globalData")));
    if (
      !params?.state?.brouillon &&
      !id_session_formation &&
      !params?.state?.etat
    ) {
      lancementSessionFormation();
    }

    if (!params?.state?.id_affaire) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#195A99",
          lineWidth: 1,
          fontFamily: "open sans, Helvetica, Arial, sans-serif",
        },
        components: {
          DatePicker: { colorPrimaryHover: "#195A99" },
          Radio: { colorPrimary: "#195A99" },
          Input: {
            // lineWidth: 2,
            // colorBorder: "#195A99",
            colorPrimaryHover: "#195A99",
            colorPrimary: "#195A99",
            controlHeight: 45,
            fontSize: 14,
            colorText: "#000",
          },
        },
      }}
    >
      <Card
        ref={ref}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>
              {" "}
              {typesession === "non_homologuee"
                ? "Lancement d'une session de formation non homologuée"
                : "Lancement d'une session de formation continue"}{" "}
            </span>
          </div>
        }
        bordered={false}
        style={{
          margin: "auto",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        {/* <Spin spinning={isLoading} tip="" style={{ width: "100%" }}> */}
        <Form
          noValidate
          form={form}
          layout="vertical"
          onFinish={nextStep}
          onFinishFailed={() => {
            notification.error({
              message: t("Erreur"),
              description: t("Veuillez remplir tous les champs obligatoires."),
              duration: 0,
            });
          }}
          onKeyDown={(e) => (e.key === "Enter" ? e.preventDefault() : null)}
         
        >
          <Steps
            current={currentStep}
            items={items}
            progressDot
            className="stepper"
          />
          <div className={classes.contentStyle}>
            {steps[currentStep]?.content}
          </div>
          <div
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Button
              onClick={prevStep}
              style={{ marginInline: "1rem" }}
              disabled={currentStep <= 0}
            >
              {t("Précédent")}
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              disabled={id_session_formation && currentStep === 2}
            >
              {currentStep < steps.length - 1 ? t("Suivant") : t("Valider")}
            </Button>
          </div>
        </Form>
        {/* </Spin> */}
      </Card>
    </ConfigProvider>
  );
};

export default LancementSessionFormationNonHomologuee;
